import { Button, Drawer } from 'antd';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 10px 0;

  .ant-drawer-header {
    display: none;
  }

  .ant-drawer-body {
    padding: 0 30px 10px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 12px;
  border-bottom: 1px solid #f0f0f0;
`;

export const LeftSideHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const RightSideHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Title = styled.span<{ clickable?: boolean }>`
  font-size: 16px;
  font-weight: 600;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;

export const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 18px;
  margin: 0 12px;
  background: #d9d9d9;
`;

export const StyledButton = styled(Button)`
  padding: 0 12px;
`;

export const TableContainer = styled.div`
  margin-top: 16px;
`;

export const ListToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;

export const ConditionTag = styled.span`
  display: inline-block;
  padding: 2px 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
`;

export const GroupLabel = styled.span`
  font-size: 10px;
  color: #8c8c8c;
  margin: 0 4px;
  text-transform: uppercase;
`;

export const ChannelRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 8px;
`;

export const SummaryLine = styled.div`
  margin: 12px 0;
  padding: 10px 12px;
  border-radius: 6px;
  background: #f5f7fa;
  font-size: 13px;
  color: #333;
`;
